import React from "react";
import {
  getStyled,
  SFStack,
  SFTypography,
  SFLink,
  SFMaintenanceIcon,
} from "@sf-core";
import { Trans } from "react-i18next";
import env from "env";

const { styled } = getStyled();

const StyledPageWrapper = styled(SFStack)(({ theme }) => ({
  background: theme.palette.sf_bg_gradient.main,
  height: "100vh",
}));

const StyledErrorWrapper = styled(SFStack)(({ theme }) => ({
  width: "100%",
  height: "100%",
  maxWidth: "778px",
  maxHeight: "370px",
  borderRadius: "8px",
  boxShadow: "0px 0px 40px 0px rgba(0, 0, 0, 0.06)",
}));

const StyledWrapper = styled(SFStack)(({ theme }) => ({
  height: "100%",
  width: "100%",
}));

const LinkText = (props) => (
  <SFLink underline="hover" variant="body2" href={`mailto:${props.text}`}>
    {props.text}
  </SFLink>
);

const StyledContainer = styled(SFStack)(({ theme }) => ({
  padding: theme.spacing(1),
}));

const StyledMaintenanceIcon = styled(SFMaintenanceIcon)(({ theme }) => ({
  width: "280px",
  height: "215px",
  flexShrink: 0,
}));

const StyledTypography = styled(SFTypography)(({ theme }) => ({
  textAlign: "center",
  width: "100%",
  maxWidth: "439px",
}));

const Maintenance = () => {
  return (
    <StyledPageWrapper
      direction="row"
      alignItems="center"
      justifyContent="center"
    >
      <StyledErrorWrapper
        direction="row"
        alignItems="center"
        justifyContent="center"
      >
        <StyledWrapper alignItems="center" justifyContent="center">
          <StyledContainer
            alignItems="center"
            justifyContent="center"
            spacing={1.5}
          >
            <StyledMaintenanceIcon />
            <StyledTypography variant="body2">
              <Trans
                i18nKey="signinScreen.support"
                values={{ supportMail: env.REACT_APP_SUPPORT_EMAIL }}
                components={{ link: <LinkText /> }}
              />
            </StyledTypography>
          </StyledContainer>
        </StyledWrapper>
      </StyledErrorWrapper>
    </StyledPageWrapper>
  );
};

export default Maintenance;
